/**
 * Router Utility
 * Sage-like routing system that fires functions based on body classes
 *
 * Usage:
 * 1. Register page modules with router.register()
 * 2. Call router.loadEvents() on DOM ready
 * 3. Each page module can have init() and finalize() methods
 */

class Router {
  constructor() {
    this.routes = {};
  }

  /**
   * Register a page module
   * @param {string} route - Route name (body class)
   * @param {Object} callbacks - Object with init/finalize methods
   */
  register(route, callbacks) {
    this.routes[route] = callbacks;
  }

  /**
   * Fire a route's callback
   * @param {string} route - Route name
   * @param {string} event - Event name (init or finalize)
   * @param {*} args - Arguments to pass to callback
   */
  fire(route, event = 'init', args) {
    const callbacks = this.routes[route];

    if (callbacks && typeof callbacks[event] === 'function') {
      callbacks[event](args);
    }
  }

  /**
   * Load events based on body classes
   * This is the main entry point that fires all page-specific code
   */
  loadEvents() {
    // Fire common init
    this.fire('common');

    // Get all body classes and normalize them (replace dashes with underscores)
    const bodyClasses = document.body.className
      .replace(/-/g, '_')
      .split(/\s+/)
      .filter(Boolean);

    // Fire page-specific init and finalize for each body class
    bodyClasses.forEach(className => {
      this.fire(className);
      this.fire(className, 'finalize');
    });

    // Fire common finalize
    this.fire('common', 'finalize');
  }
}

// Create and export a single router instance
export const router = new Router();

// Export the class as well for testing
export default Router;
